import { Component, HostBinding, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';

import { pageTransitions } from '../../../../../../../shared/animations/page-transitions';
import { AddSubOrgPageContent } from '../../../../../../../shared/models/add-suborg-info';
import { AddSubOrganizationService } from '../../../../../../services/add-suborg.service';

@Component({
	selector: 'copo-step-organization-details',
	templateUrl: './step-organization-details.component.html',
	styleUrl: './step-organization-details.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		FormsModule,
		ReactiveFormsModule,

		MatFormFieldModule,
		TranslateModule,

		MatInputModule,

		MatButtonModule,
		MatIconModule,
	],
})
export class StepOrganizationDetailsComponent extends AddSubOrgPageContent implements OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;
	organizationForm!: FormGroup;
	sub?: Subscription;
	organizationName?: string;
	vatNumber?: string;
	constructor(
		readonly router: Router,
		private readonly addSubOrgService: AddSubOrganizationService,
	) {
		super();
		this.organizationForm = new FormGroup({
			orgName: new FormControl('', Validators.required),
			vatNumber: new FormControl('', Validators.required),
		});
		this.sub = this.addSubOrgService.organizationName
			.subscribe(organizationName => {
				this.organizationName = organizationName;
			});
		this.sub = this.addSubOrgService.vatNumber
			.subscribe(vatNumber => {
				this.vatNumber = vatNumber;
			});
		if (this.organizationName || this.vatNumber) {
			this.organizationForm.get('orgName')?.patchValue(this.organizationName);
			this.organizationForm.get('vatNumber')?.patchValue(this.vatNumber);
		}
		this.organizationForm.get('orgName')?.valueChanges
			.pipe(debounceTime(500))
			.subscribe({
				next: (value: string) => {
					this.addSubOrgService.updateOrganizationName(value);
					this.addSubOrgService.updateIsAnyOneOrgChoiceSelected(false);
					this.addSubOrgService.updateNodeSelectedMatchingOrgs(undefined);
					this.addSubOrgService.updateVatNumberExists(false);
					this.addSubOrgService.updateIsNewSubOrg(false);
					this.addSubOrgService.setSelectedUser(undefined);
					this.addSubOrgService.updateNodeSelectedUsers(undefined);
				}
			});
		this.organizationForm.get('vatNumber')?.valueChanges
			.pipe(debounceTime(500))
			.subscribe({
				next: (value: string) => {
					this.addSubOrgService.updateVatNumber(value);
					this.addSubOrgService.updateIsAnyOneOrgChoiceSelected(false);
					this.addSubOrgService.updateNodeSelectedMatchingOrgs(undefined);
					this.addSubOrgService.updateVatNumberExists(false);
					this.addSubOrgService.updateIsNewSubOrg(false);
					this.addSubOrgService.setSelectedUser(undefined);
					this.addSubOrgService.updateNodeSelectedUsers(undefined);
				}
			});
	}

	checkErrors(): boolean | undefined {
		this.organizationForm.markAllAsTouched();
		return this.organizationForm.valid;
	}

	ngOnDestroy() {
		if (this.sub !== undefined) {
			this.sub.unsubscribe();
		}
	}
}
